const loaded = new Map();

function once(key, loader) {
  if (!loaded.has(key)) {
    loaded.set(key, Promise.resolve().then(loader).catch((error) => {
      loaded.delete(key);
      throw error;
    }));
  }
  return loaded.get(key);
}

export function ensureNavigatorStyles() {
  return once('navigator', () => import('./navigator.css'));
}

export function ensureInterfaceStyle(style = 'default') {
  switch (style) {
    case 'bento':
    case 'night':
      return once('style:bento-night', () => import('./layers/30-bento-night.css'));
    case 'kawaii':
      return once('style:kawaii', () => import('./layers/31-kawaii.css'));
    case 'tor':
      return once('style:tor', () => import('./layers/32-tor.css'));
    case 'khokhloma':
      return once('style:khokhloma', () => import('./layers/33-khokhloma.css'));
    case 'rzd':
      return once('style:rzd', () => import('./layers/34-rzd.css'));
    case 'gzhel':
      return once('style:gzhel', () => import('./layers/35-gzhel.css'));
    default:
      return Promise.resolve();
  }
}

export function preloadOptionalStyles({ interfaceStyle = 'default', navigator = false } = {}) {
  const tasks = [ensureInterfaceStyle(interfaceStyle)];
  if (navigator) tasks.push(ensureNavigatorStyles());
  return Promise.all(tasks);
}
